import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(theme => ({
    filterLine: {
        marginBottom: theme.spacing(4),
    },
    actionLine: {
        marginBottom: theme.spacing(4),

        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    actionGroup: {
        marginLeft: 'auto',
    },
}));